var CouponInfoModel = function (pageModelHndl) {
    var that = this;

    that.NetValueWithoutCurrentPosition = ko.observable(0);
    that.IsPercent = ko.observable(true);
    that.IsPersistant = ko.observable(false);
    that.CouponValue = ko.observable(10);

    that.CouponValueDisplay = ko.computed(function () {
        if (that.IsPercent())
            return that.CouponValue() + '%';
        else {
            return GetCurrency(that.CouponValue());
        }
    }, that);

    that.PriceAfterChangeWithoutCoupon = ko.computed(function () {
        return pageModelHndl.pCalculationModel.TotalNetPrice() + that.NetValueWithoutCurrentPosition();
    }, that);

    that.OrderPriceAfterChange = ko.computed(function () {
        if (that.IsPercent()) {
            return GetCurrency(that.PriceAfterChangeWithoutCoupon() - (that.PriceAfterChangeWithoutCoupon() * that.CouponValue() / 100));
        } else {
            var price = that.PriceAfterChangeWithoutCoupon() - that.CouponValue();
            if (price < 0)
                return GetCurrency(0);
            return GetCurrency(price);
        }
        return GetCurrency(that.PriceAfterChangeWithoutCoupon());
    }, that);

    that.RemainingCouponValue = ko.computed(function () {
        if (that.PriceAfterChangeWithoutCoupon() > that.CouponValue()) {
            return 0;
        } else {
            return that.CouponValue() - that.PriceAfterChangeWithoutCoupon();
        }
    }, that);

    that.RemainingCouponValueDisplay = ko.computed(function () {
        return GetCurrency(that.RemainingCouponValue());
    }, that);

    that.Populate = function (json) {
        that.NetValueWithoutCurrentPosition(json.NetValueWithoutCurrentPosition);
        that.IsPercent(json.IsPercent);
        that.IsPersistant(json.IsPersistant);
        that.CouponValue(json.CouponValue);
    };
}